<template>
  <el-container class="frequentSetup">
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <div class="formTitle">基本规则</div>
        <el-row>
          <el-col :span="16">
            <el-form-item label="出没次数次数≤" style="width: 100%">
              <el-slider
                v-model="tableParams.minCarCount"
                show-input
              ></el-slider>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="高发时段">
          <el-time-picker
            v-model="dayOut"
            is-range
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-time-picker>
        </el-form-item>
        <!-- <div class="formTitle"><span></span>车牌规则</div>
        <div class="carRule">
          <pathDialog
            ref="pathDialogRef"
            v-model:includes="tableParams.includes"
            v-model:rejects="tableParams.rejects"
            :showFooter="false"
          ></pathDialog>
        </div> -->
      </el-form>
    </el-card>
    <div class="footerBtn">
      <h-button type="primary" @click="handelParams">确定</h-button>
      <h-button @click="close" type="">取消</h-button>
    </div>
  </el-container>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect, ref } from "vue";

import util from "@util/js";
import moment from "moment";
export default defineComponent({
  name: "frequentSetup",
  components: {},
  props: {},
  setup(props, context) {
    const data = reactive({
      tableParams: {
        beginGfsf: "06:00",
        endGfsf: "18:00",
        minCarCount: 10,
      },
      tableData: [],
      columns: [
        { type: "selection" },
        {
          label: "车牌号码",
          slot: "carNumber",
        },
        {
          label: "规则名称",
          prop: "sexDict", // sex
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      dayOut: [new Date(2022, 9, 10, 8, 50), new Date(2022, 9, 10, 18, 40)],
    });
    const refData = toRefs(data);
    const pathDialogRef = ref();
    const handelParams = () => {
      pathDialogRef.value && pathDialogRef.value.submit();
      context.emit("getParams", data.tableParams);
      console.log(data.tableParams);
      context.emit("closeDialog");
    };
    const close = () => {
      context.emit("closeDialog");
    };
    watchEffect(() => {
      data.tableParams.beginGfsf = moment(data.dayOut[0]).format("HH:mm");
      data.tableParams.endGfsf = moment(data.dayOut[1]).format("HH:mm");
    });
    return {
      ...refData,
      pathDialogRef,
      handelParams,
      close,
    };
  },
});
</script>
<style lang="scss" scoped>
.frequentSetup {
  width: 100%;

  display: flex;
  flex-direction: column;
  .el-slider {
    width: 100%;
  }
  .tabs-card {
    flex: 1;
    height: 80%;
    .demo-form-inline {
      height: 100%;

      .carRule {
        height: 100%;
        .pathDialog {
          height: 100%;
        }
      }
    }
    .table-box {
      height: 30%;
    }
  }
  .footerBtn {
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
  .leftInput {
    margin-left: 20px;
  }
}
</style>
